import cookies from 'browser-cookies';

export function makePersistData(storageEngine, defaultKey){
    return function persistData(value, key = defaultKey) {
        const stringifiedValue = JSON.stringify(value);
        storageEngine.setItem(key, stringifiedValue);
    };
}

export function makeRetrieveData(storageEngine, defaultKey){
    return function retrieveData(key = defaultKey){
        const value = storageEngine.getItem(key);
        try {
            return JSON.parse(value);
        }
        catch(e){
            return unescapeQuotes(value);
        }
    };
}

export function makeDestroyData(storageEngine, defaultKey) {
    return function destroyData(key = defaultKey){
        storageEngine.removeItem(key);
    };
}

function unescapeQuotes (value) {
    return value && value.replace(/("|')/g, '');
}

function makeCookiesStorageEngine({
    cookiesEngine
}){
    return {
        removeItem: key => cookiesEngine.erase(key),
        setItem: (key, value) => cookiesEngine.set(key, value),
        getItem: key => cookiesEngine.get(key)
    };
}

const cookieStorageEngine = makeCookiesStorageEngine(cookies);

export function getStorageEngine(requestedEngine){
    return window[requestedEngine] || cookieStorageEngine;
}
